"use client";

import { Container, Stack, Text, Title } from "@mantine/core";

import type { Article } from "../_content/types";
import { ArticleFaq } from "./ArticleFaq";
import { renderInline } from "./inline";
import { renderSection } from "./sections";

interface ArticleViewProps {
  article: Article;
}

export function ArticleView({ article }: ArticleViewProps) {
  return (
    <Container size="md" py="3xl">
      <Stack gap="2xl">
        <Stack gap="md">
          <Title order={1}>{article.title}</Title>
          {article.lede && (
            <Text size="lg" c="dimmed">
              {renderInline(article.lede)}
            </Text>
          )}
        </Stack>

        {article.sections.map((section, index) => (
          <div key={index}>{renderSection(section)}</div>
        ))}

        {article.faq && article.faq.length > 0 && <ArticleFaq items={article.faq} />}
      </Stack>
    </Container>
  );
}
